import { ChevronRight, ChevronLeft, X } from "lucide-react";
import { useSetup } from "../SetupContext";

const SLIDERS = [
  { key: "costWeight"          as const, label: "Supplier consolidation threshold",           color: "#7C3AED" },
  { key: "riskTolerance"       as const, label: "Classification confidence threshold",                color: "#7C3AED" },
  { key: "consolidationTarget" as const, label: "Supplier Matching (Fuzzy Matching Threshold)", color: "#7C3AED" },
];

export function SubStep3({ onNext, onBack, onCancel }: { onNext: () => void; onBack: () => void; onCancel: () => void }) {
  const { form, setField } = useSetup();
  return (
    <div>
      <div className="setup-form-header">
        <div className="setup-form-title">Step 3 · Workflow configuration</div>
        <div className="setup-form-desc">Define automation and human-in-the-loop thresholds</div>
      </div>

      <div className="slider-section">
        {SLIDERS.map((s) => (
          <div key={s.key} className="slider-group">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div className="slider-group__label">{s.label}</div>
            </div>
            <input
              type="range"
              min={0}
              max={100}
              value={form[s.key]}
              onChange={(e) => setField(s.key, Number(e.target.value))}
              aria-label={s.label}
              aria-valuenow={form[s.key]}
              style={{
                width: "100%", height: 6, borderRadius: 3, outline: "none",
                appearance: "none", cursor: "pointer",
                background: `linear-gradient(to right, ${s.color} 0%, ${s.color} ${form[s.key]}%, var(--border) ${form[s.key]}%, var(--border) 100%)`,
              }}
            />
            <div className="slider-value" style={{ color: "#101828", fontWeight: 700 }}>{form[s.key]}% match</div>
          </div>
        ))}
      </div>

      <div className="wizard-action-bar" style={{ marginTop: 24 }}>
        <button type="button" className="action-bar__cancel btn btn--outline" onClick={onCancel}>
          Cancel
        </button>
        <button type="button" className="btn btn--outline m-left-auto" onClick={onBack}>
          <ChevronLeft size={14} /> Back
        </button>
        <button type="button" className="btn btn--primary" onClick={onNext}>
          Continue
        </button>
      </div>
    </div>
  );
}
